import React, { useState } from 'react';
import { leadership } from '../data/mock';
import { Sparkles, Linkedin, Mail, ChevronRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const Team = () => {
  const [expandedMember, setExpandedMember] = useState(null);

  const toggleExpanded = (id) => {
    setExpandedMember(expandedMember === id ? null : id);
  };

  // Fake portrait images for team
  const portraitImages = [
    'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400', // Professional woman - Asli Zeynep
    'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400', // Professional man - Murat
    'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400', // Professional man 2 - Birtan
    'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400', // Professional man 3 - Hilmi
    'https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400'  // Professional man 4 - Aykut
  ];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-purple-600 via-purple-700 to-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full mb-8">
            <Sparkles className="w-4 h-4 text-purple-300" />
            <span className="text-sm text-white/90">Leadership</span>
          </div>
          <h1 className="text-6xl md:text-7xl font-extralight mb-6 tracking-tight">
            Visionaries
            <br />
            <span className="text-purple-200">Shaping Tomorrow</span>
          </h1>
          <p className="text-xl text-white/80 max-w-3xl mx-auto font-light">
            Meet the exceptional minds driving innovation at AZB Solutions
          </p>
        </div>
      </section>

      {/* Leadership Team - Modern Card Grid */}
      <section className="py-32 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {leadership.map((member, index) => (
              <div
                key={member.id}
                className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 group"
              >
                {/* Image with overlay */}
                <div className="relative h-80 overflow-hidden">
                  <img
                    src={portraitImages[index]}
                    alt={member.name}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                  
                  {/* Name and Title on Image */}
                  <div className="absolute bottom-6 left-6 right-6">
                    <h3 className="text-2xl font-light text-white mb-1">{member.name}</h3>
                    <p className="text-purple-300 text-sm font-medium">{member.title}</p>
                  </div>
                  
                  {/* Social Icons */}
                  <div className="absolute top-6 right-6 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <button className="w-10 h-10 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center hover:bg-white/30 transition-colors">
                      <Linkedin className="w-4 h-4 text-white" />
                    </button>
                    <a 
                      href={`mailto:${member.email}`}
                      className="w-10 h-10 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
                    >
                      <Mail className="w-4 h-4 text-white" />
                    </a>
                  </div>
                </div>

                {/* Bio Content */}
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3 text-purple-600">
                    <Mail className="w-4 h-4" />
                    <a href={`mailto:${member.email}`} className="text-sm hover:underline">
                      {member.email}
                    </a>
                  </div>
                  
                  <p className="text-gray-700 text-sm leading-relaxed mb-4">
                    {expandedMember === member.id ? member.fullBio : member.bio}
                  </p>
                  
                  <button
                    onClick={() => toggleExpanded(member.id)}
                    className="flex items-center gap-2 text-purple-600 hover:text-purple-700 text-sm font-medium transition-colors"
                  >
                    {expandedMember === member.id ? 'Show Less' : 'Read More'}
                    <ChevronRight className={`w-4 h-4 transition-transform ${expandedMember === member.id ? 'rotate-90' : ''}`} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Us CTA */}
      <section className="py-32 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-5xl font-light mb-6 tracking-tight">
            Join Our Journey
          </h2>
          <p className="text-xl text-white/80 mb-12 font-light">
            We're always looking for talented individuals who share our passion for innovation
          </p>
          <a
            href="mailto:hello@azbsolutions.com"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-gray-900 rounded-full hover:bg-white/90 transition-all hover:scale-105 text-base font-medium"
          >
            <Mail className="w-5 h-5" />
            Get in Touch
          </a>
        </div>
      </section>
    </div>
  );
};

export default Team;